/**
 * Module « portail » — POR-01 à POR-05.
 *
 * Portail abonné, lecture seule (ARCHITECTURE §9.1). Les écrans de connexion
 * par lien magique appartiennent à `src/auth/` (`ConnexionAbonne`,
 * `VerificationLienMagique`) et ne sont pas de ce dossier ; celui-ci ne
 * contient que ce que l’abonné voit **une fois connecté**.
 */

import { lazy } from 'react'
import type { RouteObject } from 'react-router'

const PageTransferts=lazy(()=>import('../distribution/Transferts').then(m=>({default:m.PageTransferts})))
const MesBons = lazy(() => import('../bons/public').then((m) => ({ default: m.MesBons })))

const PageAccueil = lazy(() => import('./PageAccueil').then((m) => ({ default: m.PageAccueil })))

const PageDemandes = lazy(() =>
  import('../demandes/PageDemandes').then((m) => ({ default: m.PageDemandes })),
)
const NouvelleDemande = lazy(() =>
  import('../demandes/NouvelleDemande').then((m) => ({ default: m.NouvelleDemande })),
)
const DossierDemande = lazy(() =>
  import('../demandes/DossierDemande').then((m) => ({ default: m.DossierDemande })),
)

export const routesPortail: RouteObject[] = [
  {path:'transferts',element:<PageTransferts/>},
  { path: 'bons', element: <MesBons /> },
  { path: 'demandes', element: <PageDemandes /> },
  { path: 'demandes/nouveau', element: <NouvelleDemande /> },
  { path: 'demandes/:id', element: <DossierDemande /> },
  {
    index: true,
    element: <PageAccueil />,
  },
]
